import React from 'react';
import { Investigator } from '../api';

interface StatisticsCardProps {
  investigator: Investigator;
  className?: string;
}

const formatRollDistribution = (counts?: number[]) => {
  if (!counts || counts.length < 7) {
    return '—';
  }

  return counts
    .slice(1, 7)
    .map((count, idx) => `${idx + 1}:${count}`)
    .join('  ');
};

export const StatisticsCard: React.FC<StatisticsCardProps> = ({ investigator, className }) => {
  const stats = investigator.statistics;
  if (!stats) return null;

  const distribution = formatRollDistribution(stats.rollValueCounts);
  const cardClassName = ['statistics-card', className].filter(Boolean).join(' ');

  return (
    <div className={cardClassName}>
      <h5>{investigator.name}</h5>
      <p>Rolls: {stats.diceRolls} | Successes: {stats.diceRollSuccesses}</p>
      <p>Rolls by face: {distribution}</p>
      <p>Clues spent: {stats.cluesSpent} | Money spent: ${stats.moneySpent}</p>
      <p>Damage taken — Stamina: {stats.staminaDamageTaken}, Sanity: {stats.sanityDamageTaken}</p>
      <p>Monsters defeated: {stats.monstersDefeated} | Gates closed: {stats.gatesClosed} | Gates sealed: {stats.gatesSealed ?? 0}</p>
      <p>Damage to Ancient One: {stats.damageToAncientOne}</p>
      <p>Movement: {stats.movementsMade} | Trains Taken: {stats.trainRides}</p>
      <p>Knockouts: {stats.knockouts} | Insanities: {stats.timesDrivenInsane}</p>
    </div>
  );
};
